import { Col, Container, Row } from 'react-bootstrap';

import { Layout } from '@utilities';

import Page from '../../layouts/Page';
import RecentReports from './components/RecentReports';
import ThoughtLeadership from './components/ThoughtLeadership';
import Welcome from './components/Welcome';

const Home = () => {
  return (
    <Page>
      <Layout.Column>
        <Welcome />
        <Container>
          <Row>
            <Col xs={6}>
              <RecentReports />
            </Col>
            <Col xs={6}>
              <ThoughtLeadership />
            </Col>
          </Row>
        </Container>
      </Layout.Column>
    </Page>
  );
};
export default Home;
